import { tryGetHostApi } from "../app/externalApi/externalApi";
import { addPartCData } from "./TraceLogging";
// Wrapper class for logging Critical Data events
// Critical data events are collected at 100% sampling for all devices. As such, this type of event requires special approval.
// If your event does not have special approval, it will be turned off immediately.
// Critical events are expensive. Consider using Telemetry or Measures and applying OneSettings overrides if 100% sampling is needed
// See https://www.osgwiki.com/wiki/Telemetry_categories for extra information
export class CriticalData {
    static async logEvent(provider, eventName, privacyTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 140737488355328 /* criticalData */, 0 /* none */, 0 /* verbose */, await addPartCData(partC));
        }
    }
    static async logEventWithTag(provider, eventName, privacyTag, eventTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 140737488355328 /* criticalData */, eventTag, 0 /* verbose */, await addPartCData(partC));
        }
    }
    static async logEventWithLevel(provider, eventName, privacyTag, loggingLevel, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 140737488355328 /* criticalData */, 0 /* none */, loggingLevel, await addPartCData(partC));
        }
    }
    static async logEventWithLevelAndTag(provider, eventName, privacyTag, loggingLevel, eventTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 140737488355328 /* criticalData */, eventTag, loggingLevel, await addPartCData(partC));
        }
    }
}
